import { useEffect, type ReactNode } from "react";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Forces light mode for unauthenticated pages (login, register, etc.)
 */
export function LightModeWrapper({ children }: { children: ReactNode }) {
  const { setForcedLight } = useTheme();

  useEffect(() => {
    setForcedLight(true);
    return () => setForcedLight(false);
  }, [setForcedLight]);

  return <>{children}</>;
}
